export const getImage = async (url) => {
  return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = () => resolve(false);
      img.src = url;
  });
}